import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-custom-dob',
  templateUrl: './custom-dob.component.html',
  styleUrls: ['./custom-dob.component.css']
})
export class CustomDobComponent implements OnInit {

  @Input() applicantIndex: any;
  @Input() questionID: any;
  @Input() submitted: any;
  @Input() application: any;
  @Output() recallTriageRules = new EventEmitter<any>();
  @Output() recallConditionalQuestionsCheck = new EventEmitter<any>();
  @Output() recallQuestionCheck = new EventEmitter<any>();

  dobForm: FormGroup;

  constructor(
    private cdref: ChangeDetectorRef
  ) { }

  // Getter for easy access to form fields
  get form() { return this.application.controls.dobForm.controls; }

  months = [
    { id: 0, name: 'January | Eanáir' },
    { id: 1, name: 'February | Feabhra' },
    { id: 2, name: 'March | Márta' },
    { id: 3, name: 'April | Aibreán' },
    { id: 4, name: 'May | Bealtaine' },
    { id: 5, name: 'June | Meitheamh' },
    { id: 6, name: 'July | Iúil' },
    { id: 7, name: 'August | Lúnasa' },
    { id: 8, name: 'September | Meán Fómhair' },
    { id: 9, name: 'October | Deireadh Fómhair' },
    { id: 10, name: 'November | Samhain' },
    { id: 11, name: 'December | Nollaig' }
  ];

  ngOnInit(): void {
    this.dobForm = this.application.controls.dobForm;
  }

  // dob input text validation
  keyPressDobField(event: any) {
    // Remove everything but digits
    const pattern = /\D+/g;
    if (pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/\D+/g, '');
    }

    // If the above removes all input, we dont want to run the below code to check
    // The dates
    if (event.target.value.length >= 1) {

      this.recallTriageRules.emit(event);
      this.recallConditionalQuestionsCheck.emit(this.applicantIndex);
      this.cdref.detectChanges();
    }
  }

  onQuestionChange($event) {
    const emitObj = {
      $event,
      i: this.applicantIndex,
      id: this.questionID
    }
    this.recallQuestionCheck.emit(emitObj);
    this.cdref.detectChanges();
  }
}
